import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SuperAdminEditFAQ from "./SuperAdminEditFAQ";
import { Button, Image, Modal } from "react-bootstrap";

import { delete_help_faq } from "../../../../store/actions/SuperAdminActions/superAdminFAQAction";
import isEmpty from "../../../../store/validation/is-Empty";

const SuperAdminHelpFAQdisplayModal = (props) => {
  let dispatch = useDispatch();
  const [TrDetail, setTrDetail] = useState({ TrDetail: false });
  const showTr = () => setTrDetail({ TrDetail: !TrDetail.TrDetail });
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(!show);

  const token = useSelector((state) => {
    return !isEmpty(state.auth.user) ? state.auth.user.accessToken : null;
  });

  const deleteAction = (data) => {
    const categoryID = data && data.category_id._id;
    dispatch(delete_help_faq(data._id, token, categoryID, onSuccessDelete));
  };

  const onSuccessDelete = () => {
    handleShow();
  };

  return (
    <>
      <tbody>
        <tr
          className="super_admin_all_users_table_body super-admin-list-icon-image cursor rounded-0"
          onClick={showTr}
        >
          <td style={{ width: "15%" }}>
            <div className="f14-500 p-4">{props.serialNo}</div>
          </td>
          <td style={{ width: "85%" }}>
            <div className="f12-500">{props.question}</div>
          </td>
        </tr>
        {TrDetail.TrDetail && (
          <tr
            className="border border-bottom-0 border-light rounded-0 bg-white"
            style={{ boxShadow: "0px 2px 4px rgba(0,0,0,0.19)" }}
            onClick={(e) => {
              if (!e) var e = window.event;
              e.cancelBubble = true;
              if (e.stopPropagation) e.stopPropagation();
            }}
          >
            <td style={{ width: "80%" }}>
              <div className="f12-400">{props.answer}</div>
            </td>
            <td
              style={{ width: "20%" }}
              onClick={(e) => {
                if (!e) var e = window.event;
                e.cancelBubble = true;
                if (e.stopPropagation) e.stopPropagation();
              }}
            >
              <div className="d-flex">
                <SuperAdminEditFAQ
                  type="edit"
                  editedData={props.handleShowEdit}
                />
                <DeleteModel
                  onDeleteSubCategory={() =>
                    deleteAction(props.handleShowDelete)
                  }
                  open={show}
                  openModal={() => handleShow()}
                />
              </div>
            </td>
          </tr>
        )}
      </tbody>
    </>
  );
};

export default SuperAdminHelpFAQdisplayModal;

const DeleteModel = (props) => {
  return (
    <React.Fragment>
      <Button
        variant="link"
        className="enIconBtn mr-3"
        onClick={props.openModal}
      >
        <Image
          src={require("../../../../assets/images/UserManagement/Delete.svg")}
          alt="Delete catalog"
          title="Delete catalog"
          fluid
        />
      </Button>
      <Modal
        show={props.open}
        onHide={props.openModal}
        centered
        size="md"
        className="admin_vendor_details_popup"
      >
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title className="modal_title_header">Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="f12-500">
            Are you sure you want to delete the question?
          </div>
          <div className="mt-3 mb-2">
            <div className="d-flex align-items-center">
              <button
                type="button"
                className="btn-md mr-4 px-5 btn btn-outline-secondary"
                onClick={props.openModal}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn-md px-5 btn btn-danger"
                onClick={props.onDeleteSubCategory}
              >
                Delete
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};
